import { Control } from 'react-hook-form';

import { EFilterType, IFilterSchemeResponse } from '@patient-fi/fed-types';

import { getLabelName } from '../../../utilities/getLabelName';
import { DatePicker, Input, MultiSelect, Select } from '../../index';

interface FilterProps {
  filter: IFilterSchemeResponse;
  control?: Control;
}

function FilterItem(props: FilterProps) {
  const { filter, control } = props;
  const { filterQueryName, filterType, documentColumnName } = filter;
  switch (filterType) {
    case EFilterType.NUMBER:
      return <Input control={control} type="number" fullWidth name={filterQueryName} label={getLabelName(filterQueryName)} />;
    case EFilterType.DATE:
      return <DatePicker control={control} inputProps={{ fullWidth: true }} name={filterQueryName} label={getLabelName(filterQueryName)} />;
    case EFilterType.SELECT:
      const SelectComponent = filter.multiSelect ? MultiSelect : Select;
      return (
        <SelectComponent
          control={control}
          fullWidth
          name={filterQueryName}
          options={filter.options ? filter.options : []}
          label={getLabelName(filterQueryName)}
        />
      );
    default:
      return <Input control={control} fullWidth name={filterQueryName} label={getLabelName(documentColumnName)} />;
  }
}

export default FilterItem;
